var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card black"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.viewText)}}),_c('span',{staticClass:"pick",class:{hidden: _vm.hidePickNumber}},[_vm._v(_vm._s(_vm.card.pick))])])}
var staticRenderFns = []

export { render, staticRenderFns }